export default function FutureMineralsCountriesOpportunitiesContainerLoading() {
  return (
    <div className="mt-8 animate-pulse">
      <div className="mb-4">
        <div className="bg-muted-300 mb-4 h-8 w-52 text-3xl font-black" />
        <div>
          <div className="mb-2 flex items-center justify-start gap-2">
            <div className="border-muted-300 h-10 w-10 border-2" />

            <div className="border-muted-300 h-10 w-10 border-2" />
          </div>
          <div className="mb-4 grid grid-cols-12 gap-4">
            <div className={`group col-span-6 flex items-center border-2 sm:col-span-4 md:col-span-3`}>
              <div className={`bg-light`}>
                <div className="h-16 w-16 p-2 ltr:border-r-2 rtl:border-l-2" />
              </div>
              <div className="w-64 p-2 px-4 text-center font-bold capitalize" />
            </div>
            <div className={`group col-span-6 flex items-center border-2 sm:col-span-4 md:col-span-3`}>
              <div className={`bg-light`}>
                <div className="h-16 w-16 p-2 ltr:border-r-2 rtl:border-l-2" />
              </div>
              <div className="w-64 p-2 px-4 text-center font-bold capitalize" />
            </div>
            <div className={`group hidden items-center border-2 sm:col-span-4 sm:flex md:col-span-3`}>
              <div className={`bg-light`}>
                <div className="h-16 w-16 p-2 ltr:border-r-2 rtl:border-l-2" />
              </div>
              <div className="w-64 p-2 px-4 text-center font-bold capitalize" />
            </div>
            <div className={`group hidden items-center border-2 md:col-span-3 md:flex`}>
              <div className={`bg-light`}>
                <div className="h-16 w-16 p-2 ltr:border-r-2 rtl:border-l-2" />
              </div>
              <div className="w-64 p-2 px-4 text-center font-bold capitalize" />
            </div>
          </div>
          <div className="flex items-end gap-4">
            <div className="bg-muted-300 h-24 w-24" />
            <div className="bg-muted-300 h-10 w-full sm:w-1/2" />
          </div>
        </div>
      </div>
      <div className="my-8 grid grid-cols-12 gap-6">
        {[...Array(6)].map(() => (
          <div className="border-muted-300 col-span-12 border-2 md:col-span-6">
            <div className="border-muted-300 h-16 select-all border-b-2 bg-light p-4 px-6 font-bold" />
            <div className="flex flex-col gap-4 p-4 px-6">
              <div className="bg-muted-300 flex h-5 w-32" />
              <div className="bg-muted-300 flex h-5 w-28" />
              <div className="bg-muted-300 flex h-5 w-40" />
              <div className="bg-muted-300 flex h-5 w-24" />
            </div>
            <div className="border-muted-300 h-16 border-t-2 bg-light p-4 px-6" />
          </div>
        ))}
      </div>
    </div>
  )
}
